import { Controller } from "@hotwired/stimulus"
import SignaturePad from "signature_pad"

export default class extends Controller {
  static targets = ["canvas", "imageField"]

  connect() {
    this.signaturePad = new SignaturePad(this.canvasTarget)
    this.resizeCanvas()

    // Resize canvas on window resize
    window.addEventListener('resize', this.resizeCanvas.bind(this))

    // Listen for form submission to capture signature
    const form = this.element.closest('form')
    if (form) {
      this.form = form
      this.form.addEventListener('submit', this.captureSignature.bind(this))
    }
  }

  disconnect() {
    window.removeEventListener('resize', this.resizeCanvas.bind(this))
    if (this.form) {
      this.form.removeEventListener('submit', this.captureSignature.bind(this))
    }
  }

  resizeCanvas() {
    const ratio = Math.max(window.devicePixelRatio || 1, 1)
    const canvas = this.canvasTarget
    canvas.width = canvas.offsetWidth * ratio
    canvas.height = canvas.offsetHeight * ratio
    canvas.getContext("2d").scale(ratio, ratio)
    this.signaturePad.clear()
  }

  clear() {
    this.signaturePad.clear()
    this.imageFieldTarget.value = ""
    // Trigger autosave to clear the field
    this.triggerAutosave()
  }

  captureSignature(event) {
    // Only capture if there's a signature
    if (!this.signaturePad.isEmpty()) {
      // Get the canvas data as base64
      const dataURL = this.canvasTarget.toDataURL()
      // Store it in the hidden field
      this.imageFieldTarget.value = dataURL
    }
  }

  // Method to save signature immediately via Turbo
  saveSignature() {
    if (this.signaturePad.isEmpty()) {
      alert("Please provide a signature first")
      return
    }

    // Capture the signature data
    const dataURL = this.canvasTarget.toDataURL()
    this.imageFieldTarget.value = dataURL

    // Trigger autosave
    this.triggerAutosave()
  }

  triggerAutosave() {
    // Dispatch a change event to trigger autosave
    this.imageFieldTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }

  // Alternative method for standalone signature forms
  save(event) {
    event.preventDefault()

    if (this.signaturePad.isEmpty()) {
      alert("Please provide a signature")
      return false
    }

    // Convert to blob and then to file
    this.canvasTarget.toBlob((blob) => {
      const file = new File([blob], "signature.png", { type: "image/png" })

      // Create a data transfer to simulate file input
      const dataTransfer = new DataTransfer()
      dataTransfer.items.add(file)

      // Create a file input and attach the file
      const fileInput = document.createElement("input")
      fileInput.type = "file"
      fileInput.name = "e_signature[signature_image]"
      fileInput.files = dataTransfer.files

      // Replace the hidden field with the file input
      this.imageFieldTarget.replaceWith(fileInput)

      // Submit the form
      this.element.submit()
    })
  }
}